<template>
  <div id="signup-flow" class="login-type-page">
    <main>
      <img class="main-logo" src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" alt="logo" />
      <step-indicator
        :steps="indicatorSteps"
        :current="currentStep"
        :disabled="false"
        width="clamp(300px, 80%, 420px)"
        @click-step="stepChanged"
        signupDesign
      />
      <div class="steps">
        <transition name="s-first">
          <SignupStepOne
            v-if="currentStep == 1"
            @user-created="userCreated"
            :userRequestedPlan="userRequestedPlan"
            :userRequestedSolution="userRequestedSolution"
          />
        </transition>

        <transition :name="'s-' + midTransition">
          <SignupStepTwo
            v-if="currentStep == 2"
            @integration-created="integrationCreated"
            @cancel-flow="cancelFlow()"
          />
        </transition>

        <transition name="s-last">
          <SignupStepThree
            v-if="currentStep == 3"
            :contentSourceId="integrationData.id"
            :sourceConnected="sourceConnected"
            />
            <!-- :userRequestedSolution="userRequestedSolution" -->
        </transition>
      </div>
    </main>
    <aside>
      <div>
        <h1>
          {{ $t("signupflow.sideview.title") }}
        </h1>
        <ul class="usp-list">
          <li v-for="(item, index) in listItems" :key="index">
            <img src="@/assets/svg/circle-check.svg" alt="checkmark" class="checkmark" /><span> {{ item }}</span>
          </li>
        </ul>
      </div>
      <div class="sideview-images">
        <!-- <transition name="step-fade"> -->
        <div class="step sideview-step-1" v-show="currentStep == 1">
          <!-- <h2>The cool ones are already doing it</h2> -->
          <h2>{{ $t("signupflow.sideview.sub-titles.title-1") }}</h2>
          <div class="img-container">
            <img src="@/assets/svg/brands.png" alt="" />
          </div>
        </div>
        <!-- </transition> -->
        <!-- <transition name="step-fade"> -->
        <div class="step sideview-step-2" v-show="currentStep == 2">
          <h2>{{ $t("signupflow.sideview.sub-titles.title-2") }}</h2>
          <div class="img-container">
            <img src="@/assets/svg/integrations.png" alt="" />
          </div>
        </div>
        <!-- </transition> -->
        <!-- <transition name="step-fade">   -->
        <div class="step sideview-step-3" v-show="currentStep == 3">
          <h2>{{ $t("signupflow.sideview.sub-titles.title-3") }}</h2>
          <div class="img-container">
            <img src="@/assets/svg/product-image.webp" alt="" />
          </div>
        </div>
        <!-- </transition> -->
      </div>
      <!-- </div> -->
    </aside>
  </div>
</template>

<script>
import { stepIndicatorMixin } from "@/assets/js/stepIndicatorMixin.js";
import StepIndicator from "@/components/StepIndicator.vue";
import SignupStepOne from "@/components/SignupStepOne";
import SignupStepTwo from "@/components/SignupStepTwo";
import SignupStepThree from "@/components/SignupStepThree";
export default {
  mixins: [stepIndicatorMixin],
  components: { StepIndicator, SignupStepOne, SignupStepTwo, SignupStepThree },
  data() {
    return {
      listItems: [
        this.$t("signupflow.sideview.usp-list.item-1"),
        this.$t("signupflow.sideview.usp-list.item-2"),
        this.$t("signupflow.sideview.usp-list.item-3"),
        this.$t("signupflow.sideview.usp-list.item-4"),
        this.$t("signupflow.sideview.usp-list.item-5")
      ],
      currentStep: 1,
      indicatorSteps: [
        {
          step: 1,
          title: this.$t("signupflow.step-indicator.title-1"),
          allowed: true,
          visited: true,
          valid: false,
          disabled: false
        },
        {
          step: 2,
          title: this.$t("signupflow.step-indicator.title-2"),
          allowed: false,
          deniedAccessMsg: "We need your name and stuff first",
          visited: false,
          valid: false,
          disabled: true
        },
        {
          step: 3,
          title: this.$t("signupflow.step-indicator.title-3"),
          allowed: false,
          deniedAccessMsg: "We need a connection to your webshop before we continue :) ",
          visited: false,
          valid: false,
          disabled: true
        }
      ],
      midTransition: "mid-next",
      integrationData: {},
      userRequestedPlan: null,
      userRequestedSolution: null,
      sourceConnected: null
    };
  },

  methods: {
    stepChanged(to) {
      this.midTransition = this.nextTransition(this.currentStep, to);
      this.$nextTick(() => {
        this.currentStep = to;
      });
    },
    userCreated(userData) {
      console.log("user was created - next step");

      this.indicatorSteps[0].visited = true;
      this.indicatorSteps[0].valid = true;
      this.indicatorSteps[1].disabled = false;
      this.indicatorSteps[1].allowed = true;
      this.stepChanged(2);

      //disable first step
      this.$nextTick(() => {
        this.indicatorSteps[0].disabled = true;
      });
    },
    integrationCreated(integrationData, connected) {
      console.log("Integration was created - next step");
      console.log(integrationData, connected);
      this.integrationData = integrationData;

      // False if a connector was created but never got connected
      this.sourceConnected = connected;

      localStorage.setItem("signupSourceID", integrationData.id);
      this.indicatorSteps[1].visited = true;
      this.indicatorSteps[1].valid = true;
      this.indicatorSteps[2].disabled = false;
      this.indicatorSteps[2].allowed = true;

      this.stepChanged(3);
      //disable second step
      this.$nextTick(() => {
        this.indicatorSteps[1].disabled = true;
      });
    },
    handleQueryParams(params) {
      if (params.plan) {
        // Save the requeste plan
        switch (params.plan) {
          case "1":
            this.userRequestedPlan = 1;
            break;
          case "2":
            this.userRequestedPlan = 2;
            break;
          case "3":
            this.userRequestedPlan = 3;
            break;
          case "4":
            this.userRequestedPlan = 4;
            break;
          default:
            this.userRequestedPlan = null;
        }
      }
      if (params.solution) {
        // Save the requested solution
        switch (params.solution) {
          case "premium":
            this.userRequestedSolution = "premium";
            break;
          case "ai":
            this.userRequestedSolution = "ai";
            break;
          default:
            this.userRequestedSolution = null;
        }
      }
    },

    cancelFlow() {
      this.$store.dispatch("endSignupFlow", "NoIntegration").finally(() => {
        this.$router.push("/?quickstart=true&userCancelledFromStep=2");
      });
    }
  },
  mounted() {
    // retrieve url params
    this.handleQueryParams(this.$router.currentRoute.query);
  },
  computed: {},
  watch: {}
};
</script>

<style lang="less">
#signup-flow {
  min-height: 100vh;
  width: 100vh;
  display: flex;
  justify-content: space-between;

  main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    .steps {
      display: flex;
      flex-direction: row;
    }

    .description {
      font-size: 12px;
      color: var(--text-grey-primary);
      font-weight: 500;
      margin-bottom: 0;
    }

    .step-one,
    .step-two {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 330px;
    }

    .btn-signup-flow {
      border: none;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      width: 100%;
      text-align: left;
      padding: 12px 18px;
      font-weight: 700;
      color: var(--orange-web);
      background: var(--orange-web-20);
      margin-bottom: 4px;

      &:hover {
        background: var(--orange-web-40);
      }

      &:disabled {
        background: var(--orange-web-10);
        color: var(--orange-web-40);
        cursor: not-allowed;
      }
    }
  }

  .main-logo {
    margin-top: 80px;
    width: 220px;
    margin-bottom: 36px;
  }
  .step-indicator {
    margin-bottom: 36px;
  }

  aside {
    width: clamp(400px, 40vw, 500px);
    background: var(--signup-aside);
    padding: 80px 80px 40px 80px;
    box-shadow: inset 2px 0px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      & > li {
        display: flex;
        gap: 12px;
        margin-bottom: 24px;
        font-weight: 500;
        .checkmark {
          width: 14px;
        }
      }
    }

    .sideview-images {
      position: relative;
      .step {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      .img-container {
        height: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

@media only screen and (max-width: 1100px) {
  #signup-flow {
    display: block;
    min-height: auto;
    width: auto;
    aside {
      display: flex;
      flex-direction: row;
      margin: 0;
      margin-top: 80px;
      width: 100vw;

      .content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .sideview-images {
        align-self: end;
        margin-bottom: 0;
        .step {
          display: flex;
          flex-direction: column-reverse;
        }
      }
      .img-container {
        max-width: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
@media only screen and (max-width: 900px) {
  #signup-flow {
    aside {
      margin: 0;
      margin-top: 80px;
      display: block;
      text-align: center;
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
      }
      .sideview-images {
        .step {
          display: flex;
          flex-direction: column;
          h2 {
            margin-bottom: 24px;
          }
        }

        .img-container {
          height: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    main .step-three {
      .startup-options {
        flex-direction: column;
      }
    }
  }

  .step-three .last-step {
    max-width: 260px;
  }
}

.s-first-enter-to .s-last-enter-to {
  position: absolute;
  opacity: 1;
  transform: translateX(50px);
}
.s-first-enter,
.s-first-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-50px);
}

.s-last-enter,
.s-last-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(50px);
}
.s-first-enter-active,
.s-first-leave-active {
  // transition: all 0.2s ease;
  transition: transform 0.3s ease;
  transition: opacity 0.2s ease;
}
.s-last-leave-active,
.s-last-enter-active {
  // transition: all 0.2s ease;
  // transition-delay: 0.s-1s;
  transition: transform 0.3s ease;
  transition: opacity 0.2s ease;
}

.s-mid-next-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(50px);
}
.s-mid-next-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-50px);
}
.s-mid-next-leave-active,
.s-mid-next-enter-active {
  // transition: all .0.2s ease;
  // transition-delay:. 0.s-1s;
  transition: transform 0.3s ease;
  transition: opacity 0.2s ease;
}

.s-mid-previous-enter {
  position: absolute;
  opacity: 0;
  transform: translateX(-50px);
}
.s-mid-previous-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(50px);
}
.s-mid-previous-leave-active,
.s-mid-previous-enter-active {
  // transition-delay:. 0.1s;
  transition: transform 0.3s ease;
  transition: opacity 0.2s ease;
  // transition: all .0.2s ease;
}

.s-last-enter-active,
.s-mid-previous-enter-active,
.s-mid-next-enter-active,
.s-first-enter-active {
  transition-delay: 0.3s;
}
</style>
